import type { SougouPart } from '../lib/types';
import { StarRating } from './StarRating';
import { CategoryGrid } from './CategoryGrid';

interface Props {
  data: SougouPart;
}

export function SougouCard({ data }: Props) {
  return (
    <section className="card mt-4 mx-4 mb-8 bg-gradient-to-br from-white to-ink-100/40
                        dark:from-ink-800/80 dark:to-ink-900/60">
      <header className="flex items-baseline gap-3">
        <span className="label">第3部</span>
        <h2 className="card-title">総合判断</h2>
      </header>
      <div className="mt-2 flex items-center gap-3">
        <StarRating value={data.rating} label={data.ratingLabel} />
      </div>

      <p className="mt-4 text-sm leading-relaxed text-ink-700 dark:text-ink-100 whitespace-pre-line">
        {data.reading}
      </p>

      <CategoryGrid categories={data.categories} />

      {data.keywords?.length > 0 && (
        <div className="mt-5">
          <div className="label mb-2">キーワード</div>
          <div className="flex flex-wrap gap-1.5">
            {data.keywords.map((k, i) => (
              <span key={i} className="pill bg-gold-500/15 text-gold-600 dark:text-gold-400 dark:bg-gold-500/15">
                {k}
              </span>
            ))}
          </div>
        </div>
      )}

      {data.actionGuidelines?.length > 0 && (
        <div className="mt-5">
          <div className="label mb-2">行動指針</div>
          <ol className="space-y-2">
            {data.actionGuidelines.map((g, i) => (
              <li key={i} className="text-sm leading-relaxed flex gap-2">
                <span className="shrink-0 mt-0.5 inline-flex h-5 w-5 items-center justify-center
                                 rounded-full bg-gold-500/15 text-gold-600 dark:text-gold-400 text-xs font-bold">
                  {i + 1}
                </span>
                <span className="text-ink-700 dark:text-ink-100">{g}</span>
              </li>
            ))}
          </ol>
        </div>
      )}
    </section>
  );
}
